import * as MUI from "@mui/material";

type InputCelularProps = {
  situacao?: string;
  imei?: string;
  marca?: string;
  modelo?: string;
  onClick?: () => void;
};

export const ResultadoConsultaCelular: React.FC<InputCelularProps> = ({
  situacao,
  imei,
  marca,
  modelo,
  onClick,
}) => {
  return (
    <MUI.Card
      onClick={onClick}
      elevation={5}
      sx={{
        display: "flex",
        mb: 2,
      }}
    >
      <MUI.CardActionArea>
        <MUI.Stack
          display="flex"
          width="100%"
          flexDirection={["column", "row"]}
          p={0.5}
          gap={[0, 2]}
        >
          <MUI.Stack>
            <MUI.Divider
              orientation="vertical"
              sx={{
                borderWidth: 3.2,
                backgroundColor: "purple",
              }}
            />
          </MUI.Stack>
          <MUI.Stack flex={1}>
            <MUI.Typography variant="body2" fontWeight="bold">
              Situação
            </MUI.Typography>
            <MUI.Typography variant="caption">{situacao}</MUI.Typography>
          </MUI.Stack>

          <MUI.Stack flex={1}>
            <MUI.Typography variant="body2" fontWeight="bold">
              Imei
            </MUI.Typography>
            <MUI.Typography variant="caption">{imei}</MUI.Typography>
          </MUI.Stack>

          <MUI.Stack flex={1}>
            <MUI.Typography variant="body2" fontWeight="bold">
              Marca
            </MUI.Typography>
            <MUI.Typography variant="caption">{marca}</MUI.Typography>
          </MUI.Stack>

          <MUI.Stack flex={1}>
            <MUI.Typography variant="body2" fontWeight="bold">
              Modelo
            </MUI.Typography>
            <MUI.Typography variant="caption">{modelo}</MUI.Typography>
          </MUI.Stack>
        </MUI.Stack>
      </MUI.CardActionArea>
    </MUI.Card>
  );
};
